<template>
      <div class="formClass p-4 border rounded shadow">
        <h4 class="mb-4 text-primary"><i class="bi bi-file-earmark-plus"></i> Add Item For Student</h4>
        <p class="lead">Institute ID: <span class="text-muted">{{ instituteId }}</span></p>
        
        <!-- Form -->
        <form @submit.prevent="addStudentItem">
  
          <!-- Teacher Dropdown -->
<div class="form-group" v-if="teachers.length > 0">
  <label for="teacher" class="text-start d-block">
    <i class="bi bi-person-fill"></i> Teacher
  </label>
  <select v-model="form.teacher" id="teacher" class="form-control" required @change="fetchSubjects">
    <option disabled value="">Select Teacher</option>
    <option v-for="teacher in teachers" :key="teacher.id" :value="teacher.id">
      {{ teacher.user.first_name }} {{ teacher.user.last_name }}
    </option>
  </select>
</div>

<!-- Subject Dropdown (shown only after teacher selected and subjects fetched) -->
<div class="form-group" v-if="subjects.length > 0">
  <label for="subject" class="text-start d-block">
    <i class="bi bi-book-fill"></i> Subject
  </label>
  <select v-model="form.subject" id="subject" class="form-control" required>
    <option disabled value="">Select Subject</option>
    <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
      {{ subject.name }}
    </option>
  </select>
</div>

          <div class="form-group">
      <label for="grade" class="text-start d-block">
        <i class="bi bi-geo-alt-fill"></i> Payment Type
      </label>
      <select v-model="form.payType" id="grade" class="form-control" required>
        <option value="" disabled>Select Payment Type</option>
        <option v-for="payType in payTypes" :key="payType.id" :value="payType.id">
          {{ payType.payment_type }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="amount" class="text-start d-block">
        <i class="bi bi-person-fill"></i> Amount
      </label>
      <input type="number" v-model="form.amount" id="amount" placeholder="Enter amount" class="form-control" required />
    </div>

    <div class="form-group">
      <label for="payment_date" class="text-start d-block">
        <i class="bi bi-person-fill"></i> Payment Date
      </label>
      <input type="datetime-local" v-model="form.payment_date" id="payment_date" class="form-control" required />
    </div>

    <div class="form-group">
      <label for="exp_date" class="text-start d-block">
        <i class="bi bi-person-fill"></i> Expire Date
      </label>
      <input type="datetime-local" v-model="form.exp_date" id="exp_date" class="form-control" readonly />
    </div>
  
          <!-- Success Message -->
          <div v-if="successMessage" class="alert alert-success d-flex align-items-center" role="alert">
            <i class="bi bi-check-circle-fill me-2"></i> {{ successMessage }}
          </div>
  
          <!-- Error Message -->
          <div v-if="errorMessage" class="alert alert-danger d-flex align-items-center" role="alert">
            <i class="bi bi-exclamation-circle-fill me-2"></i> {{ errorMessage }}
          </div>
  
          <button type="submit" class="btn btn-primary">
            <i class="bi bi-send-fill"></i> Submit
          </button>
  
        </form>
      </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'StudentAddItem',
    
    props: {
      studentId: {
        type: Number,
        required: true,
      },
      instituteId: {
        type: Number,
        required: true,
      },
    },
  
    data() {
      return {
        form: {
          subject: '',
          teacher: '',
          payType:'',
          amount:'',
          // payment_date: this.getTodayDate(),
          payment_date: this.getTodayDateTime(),
          exp_date: '',
        },
        subjects: [],
        teachers: [],
        payTypes: [],
        successMessage: '',
        errorMessage: '',
      };
    },

    watch: {
  'form.payType'() {
    if (this.form.payment_date) {
      this.calculateExpDate(); // Recalculate expiration date if payment type is changed
    }
  },
  'form.payment_date'() {
    if (this.form.payType) {
      this.calculateExpDate(); // Recalculate expiration date if payment date is changed
    }
  },
},
  
    mounted() {
      this.fetchTeachers();
      this.fetchSubjects();
      this.fetchPayTypes();
    },
  
    methods: {
      getTodayDateTime() {
    const today = new Date();
    return this.formatDateTime(today); // Format the current date and time with seconds
  },

  calculateExpDate() {
    const paymentDate = new Date(this.form.payment_date); // Get the payment date
    switch (parseInt(this.form.payType)) {
      case 1: // Hourly: Add 1 hour to payment date
        paymentDate.setHours(paymentDate.getHours() + 1);
        break;
      case 2: // Daily: Add 1 day to payment date
        paymentDate.setDate(paymentDate.getDate() + 1);
        break;
      case 3: // 1 Weekly: Add 7 days to payment date
        paymentDate.setDate(paymentDate.getDate() + 7);
        break;
      case 4: // 2 Weekly: Add 14 days to payment date
        paymentDate.setDate(paymentDate.getDate() + 14);
        break;
      case 5: // 3 Weekly: Add 21 days to payment date
        paymentDate.setDate(paymentDate.getDate() + 21);
        break;
      case 6: // Monthly: Add 1 month to payment date
        paymentDate.setMonth(paymentDate.getMonth() + 1);
        break;
      default:
        break;
    }

    // After modification, format the expiration date
    this.form.exp_date = this.formatDateTime(paymentDate);
  },

  formatDateTime(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  // Return in the format required by <input type="datetime-local">
  return `${year}-${month}-${day} ${hours}:${minutes}`;
},

      fetchTeachers() {
    if (!this.instituteId) return; // Use the prop value instead of form field
    axios.get('/admin-get-teachers-by-institute', {
      params: { institute_id: this.instituteId }
    })
    .then(response => {
      this.teachers = response.data;
      this.form.teacher = '';
      this.subjects = [];
      this.form.subject = '';
    })
    .catch(error => console.error('Error fetching teachers:', error));
  },

  fetchSubjects() {
    if (!this.form.teacher) return;
    axios.get('/admin-get-subjects-by-teacher', {
      params: { teacher_id: this.form.teacher }
    })
    .then(response => {
      this.subjects = response.data;
      this.form.subject = '';
    })
    .catch(error => console.error('Error fetching subjects:', error));
  },
      async fetchPayTypes() {
      try {
        const response = await axios.get('/get-all-payTypes');
        this.payTypes = response.data;
      } catch (error) {
        this.errorMessage = 'Error fetching Payement types.';
      }
    },
  
      async addStudentItem() {
        const formData = new FormData();
        formData.append('studentId', this.studentId); // Include studentId
        formData.append('subject', this.form.subject);
        formData.append('teacher', this.form.teacher);
        formData.append('payment_type', this.form.payType);
        formData.append('amount', this.form.amount);
        formData.append('payment_date', this.form.payment_date);
        formData.append('exp_date', this.form.exp_date);
  
        try {
          const response = await axios.post('/student-add-item', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
  
          // Handle success response
          this.successMessage = response.data.success;
          this.errorMessage = ''; // Clear error message
  
          // Emit an event to notify parent component to fetch student items
          this.$emit('student-item-added');
          
          // Clear success message after 2 seconds
          setTimeout(() => {
            this.successMessage = ''; // Clear success message
          }, 2000); // 2000 milliseconds = 2 seconds
        } catch (error) {
          // Handle error response
          if (error.response && error.response.data.error) {
            this.errorMessage = error.response.data.error;
          } else {
            this.errorMessage = 'An unexpected error occurred.';
          }
          this.successMessage = ''; // Clear success message
        }
      },
    },
    created() {
    this.form.payment_date = this.getTodayDateTime();
  },
  };
  </script>
  
  <style lang="scss" scoped>
  .formClass {
    width: 100%;
    max-width: 400px; /* Set a maximum width for the form */
    margin: auto; /* Center the form on the page */
  }
  
  @media (max-width: 576px) {
    .formClass {
      padding: 20px; /* More padding on small screens for better touch experience */
    }
  }
  </style>
  